import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from './theme';
import store from './store';
import router from './router';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ThemeProvider theme={theme}>
    <Provider store={store}>
      <CssBaseline />
      <RouterProvider router={router} />
    </Provider>
  </ThemeProvider>
);

const notification = ReactDOM.createRoot(document.getElementById('notification'));
notification.render(
  <ToastContainer
    theme="colored"
    autoClose={1000}
    hideProgressBar
    pauseOnFocusLoss
    pauseOnHover
    draggable
    position="top-right"
    closeOnClick
  />
);
